// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"f29906e4","440":"6635009e","582":"f29906e4","808":"1b98aec6","833":"f29906e4"}[chunkId] + ".chunk.css";
};